import React from 'react';

// Rough placeholder badge (plan §5 "Icon fidelity") -- intentionally not pixel-tuned, meant to be
// hand-replaced later.
const FileXlsBadgeIcon = () => (
  <svg data-dc-tpl="219" width="64" height="64" viewBox="0 0 60 64" fill="none"
       aria-hidden="true">
    <path data-dc-tpl="220"
          d="M14 4h24l12 12v40a4 4 0 0 1-4 4H14a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4Z"
          fill="#fff" stroke="#07132B" stroke-width="2.5"
          stroke-linejoin="round"></path>
    <path data-dc-tpl="221" d="M38 4v8a4 4 0 0 0 4 4h8" fill="none"
          stroke="#07132B" stroke-width="2.5" stroke-linejoin="round"></path>
    <rect data-dc-tpl="222" x="18" y="16" width="22" height="18" rx="2"
          stroke="#1D6F42" stroke-width="2"></rect>
    <path data-dc-tpl="223" d="M18 22h22M18 28h22M26 16v18" stroke="#1D6F42"
          stroke-width="2"></path>
    <rect data-dc-tpl="224" x="2" y="38" width="40" height="18" rx="6"
          fill="#1D6F42" stroke="#07132B" stroke-width="2.5"></rect>
    <text data-dc-tpl="225" x="22" y="51.5" text-anchor="middle"
          font-family="Plus Jakarta Sans, sans-serif" font-size="11"
          font-weight="800" fill="#fff" letter-spacing=".5">XLS
    </text>
  </svg>
);

export default FileXlsBadgeIcon;
